import React from "react";
import { Fingerprint, KeyRound, ListChecks, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../i18n/LanguageProvider";
import RevealOnScroll from "../RevealOnScroll";

const securityItems = [
  {
    icon: ShieldCheck,
    title: "Sécurité des transactions",
    text: "Des parcours conçus pour protéger les opérations et leurs statuts.",
  },
  {
    icon: ListChecks,
    title: "Traçabilité des opérations",
    text: "Un suivi clair des événements importants tout au long du paiement.",
  },
  {
    icon: KeyRound,
    title: "Contrôle des accès",
    text: "Des accès structurés selon les rôles et les besoins opérationnels.",
  },
  {
    icon: Fingerprint,
    title: "Intégrations protégées",
    text: "Des échanges sécurisés et un accompagnement technique à l’intégration.",
  },
];

const HomeSecurity = () => {
  const { t } = useLanguage();

  return (
    <section
      className="ws-section ws-home-security"
      aria-labelledby="ws-home-security-title"
    >
      <div className="ws-home-security__pattern" aria-hidden="true" />
      <div className="ws-shell ws-home-security__layout">
        <RevealOnScroll
          className="ws-home-security__intro"
          variant="fade-right"
        >
          <span className="ws-kicker">{t("Sécurité et conformité")}</span>
          <h2 id="ws-home-security-title">
            {t("Des paiements conçus pour inspirer confiance")}
          </h2>
          <p>
            {t(
              "WonyaSoft accorde une attention particulière à la sécurité, à la traçabilité, au contrôle des accès et à la conformité avec les exigences applicables.",
            )}
          </p>
          <div className="ws-home-security__approval">
            <ShieldCheck size={20} aria-hidden="true" />
            <span>{t("Agrément Banque Centrale du Congo")}</span>
          </div>
          <Link className="ws-button ws-button--light" to="/compliance">
            {t("En savoir plus sur notre conformité")}
          </Link>
        </RevealOnScroll>

        <div className="ws-home-security__grid">
          {securityItems.map(({ icon: Icon, title, text }, index) => (
            <RevealOnScroll
              as="article"
              className="ws-home-security__card"
              delay={index * 80}
              key={title}
              variant="scale-in"
            >
              <Icon size={23} aria-hidden="true" />
              <h3>{t(title)}</h3>
              <p>{t(text)}</p>
            </RevealOnScroll>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeSecurity;
